import * as Yup from "yup"

const UsersManageFormValidationShema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(6, "Name must be at least 6 characters."),
})

export default UsersManageFormValidationShema
